import './HeaderListingPagePersonalizable.css';
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import getListing from '../../utils/getListing';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM } from '../../utils';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { removeQueryString } from '../Listing/index';
import { qsToObject } from '../../utils/querystring';
import { useHistory } from 'react-router-dom';
import { tokens } from '../atoms/gradientTheme';
const HeaderListingPagePersonalizable = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  let pageName = get(fields, 'data.contextItem.headerTag.jss');
  const dotSite = get(sitecoreContext, 'site.name');
  let history = useHistory();
  if (dotSite === 'dotsite') {
    pageName = get(fields, 'data.datasource.pageName');
  }
  const pageTitle = get(fields, 'pageTitle') || get(fields, 'data.datasource.pageTitle');
  const pageTitleValue = get(fields, 'pageTitle.value') || get(fields, 'data.datasource.pageTitle.value');
  const pageIntro = get(fields, 'pageIntro') || get(fields, 'data.datasource.pageIntro');
  const Color = get(params, 'Color') || '';
  const GradientColor = get(params, 'Gradient Color') || '';
  let gradient = null;
  let start = '';
  let end = '';
  const [heightGradien, setHeightGradien] = React.useState(0);
  const isMobile = canUseDOM ? window.matchMedia(`(max-width: 992px)`).matches : false;
  // const headerTag = get(fields, 'pageIntro')

  if (Color && Color.length && GradientColor && GradientColor.length) {
    // @ts-ignore
    start = tokens[Color];
    // @ts-ignore
    end = tokens[GradientColor];
    gradient = "h1u2u3zr";
  }
  const [state, setstate] = React.useState('');
  React.useEffect(() => {
    removeQueryString('type', history);
    if (canUseDOM) {
      if (Color && Color.length && GradientColor && GradientColor.length) {
        if (typeof window !== 'undefined') {
          document.querySelector('body').classList.add('colored');
          if (document.querySelector('.filter__wrapper')) {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            setHeightGradien(document.querySelector('.filter__wrapper').offsetHeight);
          }
        }
      }
      // qsToObject
      const queryParams = qsToObject(history.location.search);
      let curatorID = '';
      if (queryParams['curators.curators.Id']) {
        curatorID = queryParams['curators.curators.Id'].toLowerCase();
        let itemFilter = {
          hitsPerPage: 1,
          facetFilters: [['type:Curator'], [`objectID:${curatorID}`]]
        };
        getListing(get(params, 'SearchIndex'), itemFilter, algoliaSettings).then(hits => {
          setstate(hits && hits.hits[0].title);
        });
      }
    }
  }, []);
  if (!fields) {
    console.warn('HeaderListingPagePersonalizable component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderListingPagePersonalizable component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    className: GradientColor && gradient && GradientColor.length ? '' : Color,
    rtl: rtl,
    style: {
      '--startColor': start,
      '--endColor': end
    }
  }, Color && Color.length && GradientColor && GradientColor.length ? /*#__PURE__*/React.createElement("span", {
    className: `${gradient}`,
    style: {
      'height': isMobile ? '464px' : '700px'
    }
  }) : '', /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, pageName && pageName.value && /*#__PURE__*/React.createElement("div", {
    className: "header__category"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "c-category__text",
    tag: "span",
    field: pageName
  })), /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, pageEditing && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: pageTitle,
    className: "h2 c-title__text"
  }), !pageEditing && /*#__PURE__*/React.createElement("h1", {
    className: "h2 c-title__text"
  }, `${pageTitleValue} ${state}`))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, pageIntro && /*#__PURE__*/React.createElement(Text, {
    className: "p header__content",
    tag: "p",
    field: pageIntro
  })))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className,
    style = {}
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className} ${headerImageStyle}`
  }, children);
};
export const commonStyles = "cs7g6kx";
export const ltrStyles = "l1mw24d3";
export const rtlStyles = "rkwwdan";
export default HeaderListingPagePersonalizable;